import { useNavigate } from "react-router";
// import "./login.css";
import "../login/login.css";

import qs from "qs";
import store from "../../app/store/store";

import { setchangeRoll, setMobile, stopLoading } from "../../app/store/reducer";
import { encrypt } from "../../utils/encryption";
import Swal from "sweetalert2";
// import { LoginApi, getOtp } from "./loginApi";

import logo from "../../assets/headers/logoSMB.png";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { ENCRYPTIONKEY } from "../../utils/api";

// import { loginValidation } from "./loginValidationFunction";
import { routePath } from "../../constants/routePath";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Box,
  Button,
  Typography,
  Container,
  Grid,
  Card,
} from "@mui/material";
import { Link } from "react-router-dom";
import LogoImage from "../../assets/img/logo.svg";
import { loginValidation } from "../login/loginValidationFunction";
import { useDispatch, useSelector } from "react-redux";
import ElegantLogo from "../../assets/elegantPrimeLogo.png";
import { LoginApi } from "../login/loginApi";
import { getOtp } from "../userLogin/loginApi";
import { GetUserApi } from "../../utils/utils";

export default function AdminLogin() {
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const dispatch = useDispatch();
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [mobileNumber, setMobileNumber] = useState("");

  function generateRandomString(length) {
    const chars = "0123456789"; // Change this to include other characters if needed
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  const [loginData, setLoginData] = useState({
    username: "",
    grant_type: "implicit",
    client_id: "client",
    ismpinauth: "1",
    mpin: "",
    // mpin: "",
    password: '""',
    loggedinweb: "0",
  });
  const handleChange = (value, index) => {
    let newOtp = [...otp];
    if (/^[0-9]?$/.test(value)) {
      newOtp[index] = value;
      setOtp(newOtp);
    }
  };
  const checkTokenORReset = async () => {
    let val = await sessionStorage.getItem("smbToken");
    console.log("token name  ", val, "userDetail ");
    if (val) {
      if (userDetail.appMenu) {
        if (userDetail.appMenu !== "adminPage") {
          if (userDetail.appMenu == "Biller") {
            navigate(routePath.HOME);
          }
          if (userDetail.appMenu == "Buyer") {
            navigate(routePath.SERVICESLIST);
          }
        } else {
          navigate(routePath.HOME);
        }
      }
    }

    // sessionStorage.removeItem("smbToken")
  };
  useEffect(() => {
    checkTokenORReset();
  }, []);

  const handleKeyUp = (e, index) => {
    const nextInput = document.querySelector(`input[name=otp${index + 1}]`);
    const prevInput = document.querySelector(`input[name=otp${index - 1}]`);

    if (e.key === "Backspace" && prevInput) {
      prevInput.focus();
    } else if (nextInput && e.target.value !== "") {
      nextInput.focus();
    }
  };

  const handleForgetMPINClick = () => {
    if (mobileNumber.length !== 10) {
      Swal.fire({
        text: "Please Enter Phone Number",
        icon: "warning",
        ...swalAlertPopProps,
      });
    } else {
      const obj = { ...loginData };
      const val = loginValidation({
        ...loginData,
        username: mobileNumber,
        mpin: otp.join(""),
      });
      const randomId = Math.floor(Math.random() * 10000)
        .toString()
        .padStart(4, "0");
      obj.username = encrypt(mobileNumber + randomId, ENCRYPTIONKEY);
      obj.mpin = encrypt(otp.join("") + randomId, ENCRYPTIONKEY);

      getOtp(
        {
          Mobile: obj.username,
        },
        (res) => {
          dispatch(setMobile(obj.username));
          navigate("/otpforget"); // Navigate to /otpforget when mobileNumber is valid
        }
      );
    }
  };

  const handleSubmit = async () => {
    const obj = { ...loginData };
    const val = loginValidation({
      ...loginData,
      username: mobileNumber,
      mpin: otp.join(""),
    });
    if (val?.status) {
      console.log("mpin login ", loginData.mpin);
      const randomString = generateRandomString(4);
      const randomId = Math.floor(Math.random() * 10000)
        .toString()
        .padStart(4, "0");
      obj.username = encrypt(mobileNumber + randomId, ENCRYPTIONKEY);
      obj.mpin = encrypt(otp.join("") + randomId, ENCRYPTIONKEY);

      let loginTmp = qs.stringify(obj);

      await LoginApi(loginTmp)
        .then(async (res) => {
          await sessionStorage.setItem("smbToken", res?.data?.access_token);

          await GetUserApi().then(async (res) => {
            let data = { ...res.data.data };
            if (data?.role == "Admin") {
              dispatch(setchangeRoll("admin"));

              navigate(routePath.USERPROFILEC);
            } else {
              await sessionStorage.clear();

              Swal.fire({
                title: "This is not admin ",
                text: "Login as admin",
                icon: "error",

                ...swalAlertPopProps,
              });
            }
          });
        })
        .catch((err) => {
          if (err?.response?.status === 400) {
            Swal.fire({
              title: "Invalid Username or Password",
              text: "Please enter a valid username and password",
              icon: "error",

              ...swalAlertPopProps,
            });
            store.dispatch(stopLoading());
          }
        });

      //    const obj = { ...loginData };
      // const val = loginValidation({ ...loginData, username: mobileNumber, mpin: otp.join("") });

      // if (val?.status) {
      //   const hardcodedMobile = "5454545454";
      //   const hardcodedOTP = "1234";

      //   if (mobileNumber === hardcodedMobile && otp.join("") === hardcodedOTP) {
      //     // Simulate successful login
      //     // await sessionStorage.setItem("smbToken", "fakeToken123456");
      //     dispatch(setchangeRoll("admin"));
      //     navigate(routePath.ADVERTISEMENT);
      //     return;
      //   }
    } else {
      Swal.fire({
        title: val.title,
        text: val.text,
        icon: "warning",

        ...swalAlertPopProps,
      });
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };
  return (
    <Container maxWidth="lg" sx={{ padding: { xs: "10px", sm: "20px" } }}>
      <Card
        sx={{
          padding: { xs: "10px", sm: "20px" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          background:
            "linear-gradient(90deg, #EBEAFF 0%, #C3C3F8 36.54%, #7E7EEB 59.13%, #01008B 100%)",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "14px",
          mt: 3,
          height: "70vh",
        }}
      >
        <Grid
          container
          alignItems="center"
          spacing={2}
          sx={{ height: "100%", flex: 1 }}
        >
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={6}>
                <img
                  src={ElegantLogo}
                  alt="Elegant Logo"
                  style={{ width: "350px" }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              // onSubmit={handleSubmit}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                backgroundColor: "#fff",
                borderRadius: "20px",
                padding: "20px",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "#01008B",
                  fontWeight: 600,
                  textAlign: "center",
                  fontSize: 30,
                }}
              >
                LOG IN
              </Typography>
              <TextField
                label="Mobile Number"
                // required
                type="tel"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                sx={{ mb: 2, width: { xs: "100%", sm: "22.3rem" } }}
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  style: { fontSize: "18px" },
                }}
                onKeyPress={handleKeyPress}
                variant="outlined"
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  width: { xs: "100%", sm: "20rem" },
                  mb: 1,
                }}
              >
                <Typography
                  sx={{ color: "#01008B", fontWeight: 500, fontSize: 18 }}
                >
                  Enter MPIN
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  mb: 2,
                }}
              >
                {otp.map((value, index) => (
                  <TextField
                    key={index}
                    name={`otp${index}`}
                    type="text"
                    value={value}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyUp={(e) => handleKeyUp(e, index)}
                    inputProps={{
                      maxLength: 1,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: {
                        textAlign: "center",
                        fontSize: "24px",
                      },
                    }}
                    variant="standard" // Use standard to get underline only
                    margin="dense"
                    onKeyPress={handleKeyPress}
                    sx={{
                      width: "65px",
                      "& .MuiInput-underline:before": {
                        borderBottom: "3px solid #01008B", // Adjust color as needed
                      },
                      "& .MuiInput-underline:after": {
                        borderBottom: "3px solid #01008B", // Focused color
                      },
                      "& .MuiInputBase-input": {
                        padding: 0,
                        height: "35px",
                      },
                    }}
                  />
                ))}
              </Box>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#01008B",
                  cursor: "pointer",
                  fontSize: "18px",
                  fontWeight: "600",
                  marginTop: "10px",
                  width: { xs: "100%", sm: "22.3rem" },
                }}
                onClick={() => {
                  handleSubmit();
                }}
              >
                Log In
              </Button>
              <Box marginTop={1}>
                <Typography>
                  {/* <Link
                  style={{ 
                    color: "#2096A4",
                    cursor: "pointer",
                    fontWeight: "500",
                  }}
                >
                 Associate User Login
                </Link> */}
                </Typography>
              </Box>
              {/* <Box marginTop={2}>
                <Typography
                >
                  New to Elegant Prime? {" "}
                  <Link
                    to={routePath.REGISTRATION}
                    style={{
                      textDecoration: "none",
                      color: "#2096A4",
                      cursor: "pointer",
                      fontWeight: "600",
                    }}
                  >
                    click here to sign up!
                  </Link>
                </Typography>
              </Box> */}
              <Box marginTop={1}>
                <Typography>
                  {" "}
                  <Link
                    style={{
                      color: "#01008B",
                      cursor: "pointer",
                      fontWeight: "500",
                      textDecoration: "none",
                    }}
                    to={mobileNumber.length === 10 ? routePath.OTPFORGET : null}
                    onClick={handleForgetMPINClick}
                  >
                    Forgot MPIN?
                  </Link>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
}
